import React from 'react';

import config from '../../../../../../../config';
import StorePresenter from '../../../../../../../presenters/StorePresenter';
import InvoicePresenter from '../../../../../../../presenters/store/InvoicePresenter';

const InvoiceCell = (props) => {
  const { invoice, onDialogOpen, brand, onMarkAsPaid } = props;

  const handleDeleteClick = () => {
    onDialogOpen(invoice);
  };

  const csvPath = `${config.API_URL}/stores/${StorePresenter.id(
    brand
  )}/invoices/${InvoicePresenter.id(invoice)}/items`;

  const handleMarkAsPaid = () => onMarkAsPaid(invoice);

  return (
    <tr>
      <td>{InvoicePresenter.invoiceNumber(invoice)}</td>
      <td>{InvoicePresenter.periodReadable(invoice)}</td>
      <td>{InvoicePresenter.amountDueReadable(invoice)}</td>
      <td>{InvoicePresenter.state(invoice)}</td>
      <td>
        <a
          className="action-button -in-group"
          target="_blank"
          href={InvoicePresenter.invoicePdfUrl(invoice)}
        >
          PDF
        </a>
        <a className="action-button -in-group" target="_blank" href={csvPath}>
          XLSX
        </a>
      </td>
      <td>
        <button className="action-button -in-group" onClick={handleDeleteClick}>
          Delete
        </button>
        {InvoicePresenter.isPending(invoice) && (
          <button
            className="action-button -in-group"
            onClick={handleMarkAsPaid}
          >
            Mark as paid
          </button>
        )}
      </td>
    </tr>
  );
};

export default InvoiceCell;
